export default "__VITE_ASSET__BDLfEnP0__"